export const HELP_AUDIENCES = Object.freeze({
    DISABLED: 'disabled',
    ADMIN: 'admin',
    ALL: 'all',
});

const normaliseEnvironmentValue = (value) => (
    typeof value === 'string' ? value.trim().toLowerCase() : ''
);

export const createHelpConfig = (environment = {}) => {
    const requestedEnabled = normaliseEnvironmentValue(environment.REACT_APP_HELP_ENABLED) === 'true';
    const requestedAudience = normaliseEnvironmentValue(environment.REACT_APP_HELP_AUDIENCE);
    const requestedOrientationEnabled = normaliseEnvironmentValue(environment.REACT_APP_HELP_ORIENTATION_ENABLED) === 'true';
    const requestedOrientationAudience = normaliseEnvironmentValue(environment.REACT_APP_HELP_ORIENTATION_AUDIENCE);
    const allowedAudiences = Object.values(HELP_AUDIENCES);
    const audience = allowedAudiences.includes(requestedAudience)
        ? requestedAudience
        : HELP_AUDIENCES.DISABLED;
    const orientationAudience = allowedAudiences.includes(requestedOrientationAudience)
        ? requestedOrientationAudience
        : HELP_AUDIENCES.DISABLED;
    const enabled = requestedEnabled && audience !== HELP_AUDIENCES.DISABLED;

    return Object.freeze({
        enabled,
        audience,
        orientationEnabled: enabled
            && requestedOrientationEnabled
            && orientationAudience !== HELP_AUDIENCES.DISABLED,
        orientationAudience,
    });
};

export const HELP_CONFIG = createHelpConfig(process.env);

export const isHelpEnabledForUser = (user, config = HELP_CONFIG) => {
    if (!config?.enabled || !user) return false;
    if (config.audience === HELP_AUDIENCES.ALL) return true;

    return config.audience === HELP_AUDIENCES.ADMIN && user.role === 'admin';
};

export const isOrientationEnabledForUser = (user, config = HELP_CONFIG) => {
    if (!isHelpEnabledForUser(user, config) || !config?.orientationEnabled) return false;
    if (config.orientationAudience === HELP_AUDIENCES.ALL) return true;

    return config.orientationAudience === HELP_AUDIENCES.ADMIN && user.role === 'admin';
};
